import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "@/services/axiosAuth";
import { BILLING_CONFIG } from "./apiRoutes";

interface mutateProps {
  pricingId: string;
  communityId: string;
  id: string;
  data?: FieldValues;
}

const mutateUpdateStatus = async ({
  pricingId,
  communityId,
  id,
  data,
}: mutateProps) => {
  return await axiosAuth.put(
    `${BILLING_CONFIG(communityId)}/${pricingId}/executions/${id}/status`,
    data
  );
};

const useUpdateStatusMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdateStatus,
    ...queryParams,
  });

export default useUpdateStatusMutation;
